import { render, staticRenderFns } from "./ContentPlaceholders.vue?vue&type=template&id=b1383ece"
import script from "./ContentPlaceholders.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholders.vue?vue&type=script&lang=js"
import style0 from "./ContentPlaceholders.vue?vue&type=style&index=0&id=b1383ece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports